import React from 'react';

export const REQUIRED_ANIMATIONS = `
@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes slideUp {
  from { transform: translateY(100%); }
  to { transform: translateY(0); }
}

@keyframes gradient-x {
  0%, 100% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
}

.animate-float {
  animation: float 6s ease-in-out infinite;
}

.animate-fadeIn {
  animation: fadeIn 0.6s ease-out forwards;
}

.animate-slideUp {
  animation: slideUp 0.4s ease-out forwards;
}

.animate-gradient-x {
  background-size: 200% 200%;
  animation: gradient-x 15s ease infinite;
}

.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
`;

interface AnimationsProps {
  children: React.ReactNode;
  includeBaseStyles?: boolean;
}

const AnimationsComponent: React.FC<AnimationsProps> = ({ 
  children,
  includeBaseStyles = true 
}) => {
  return (
    <>
      {includeBaseStyles && (
        <style dangerouslySetInnerHTML={{ __html: REQUIRED_ANIMATIONS }} />
      )}
      {children}
    </>
  );
};

export { AnimationsComponent as Animations };
export type { AnimationsProps };
export default AnimationsComponent;